import { JObject } from "../../../../common/data/models";
import { buildFilterMetaToObject, buildSortParamsToString, PaginatedRequestParams, PaginatedResponse, Result } from "../../../../common/pagination";
import { endpoints } from "../../../../constants/endpoints";
import { tawreedHttpService } from "../../../../http";
import { PaymentTransaction } from "../../domain";
import { PaymentTransactionMapper } from "../mappers";

export class PaymentTransactionRepository {

    public search(request: PaginatedRequestParams): Promise<PaginatedResponse<PaymentTransaction>> {

        const params = {
            sort: request.sort ? buildSortParamsToString(request.sort) : undefined,
            page: request.page,
            size: request.size,
        };
        const data = { ...buildFilterMetaToObject(request.keyword, { ...request.filters }) };
        return tawreedHttpService.post<JObject, Result<JObject>>(endpoints.PAYMENT_TRANSACTIONS_SEARCH, data, params, undefined, 'error')
            .then(res => {
                return {
                    ...res!,
                    data: { ...res!.data!, content: res!.data!.content.map(e => PaymentTransactionMapper.fromJson(e)) ?? [] },
                };
            });
    }

    /**
     * Get partner details by id
     * @param id
     */
    public async getDetails(id: number): Promise<PaymentTransaction> {
        return tawreedHttpService.post<number, JObject>(endpoints.PAYMENT_TRANSACTIONS_GET_DETAILS, id, undefined, undefined, 'error').then(res => PaymentTransactionMapper.fromJson(res.data!));
    }
}